import styles from './list.module.css'
import { Link } from "../link/link"
import { Table } from "../table/table"
import { Action, Column, Data } from "../types"

type Props = {
    columns: Column[]
    rows: Data[]
    rowId: string
    createLabel?: string
    createHref?: string
    readOnly?: boolean
    emptyMessage?: string
    actions?: (rowIdValue: string) => Action[]
    onCreate?: () => void
    onEdit?: (rowIdValue: string) => void
    onRemove?: (rowIdValue: string) => void
    renderDetail?: (row: Data) => JSX.Element
}

export const List = (props: Props) => {
    const { columns, rows, rowId, createLabel, createHref, readOnly, emptyMessage, actions, onCreate, onEdit, onRemove, renderDetail } = props

    return (<>
        <Table
            columns={columns}
            rows={rows}
            rowId={rowId}
            createLabel={createLabel || 'Crear Nuevo'}
            createHref={createHref}
            actions={actions}
            readOnly={readOnly}
            onCreate={onCreate}
            onEdit={onEdit}
            onRemove={onRemove}
            renderDetail={renderDetail}
        />
        {rows.length === 0 && (
            <div className={styles.empty}>
                <i className={`bi bi-bricks`} />
                <span>{emptyMessage || 'Esta tabla está vacía.'}</span>
                {!readOnly && (onCreate || createHref) && (
                    <Link
                        text='Crear el primer item'
                        kind="primary"
                        to={createHref}
                        onClick={!createHref ? onCreate : undefined}
                        className={styles.emptyLink}
                    />
                )}
            </div>
        )}
    </>)
}
